import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { TEXT_MAX_CHARS } from '@/features/transaction_items/components/Form/GeneralForm/TransactionItemGeneralForm';
import { useTranslation } from '@/i18n';
import { FormInput } from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  index: number;
  property: TransactionProperty;
};

const InnerTextTypeInput = ({ index, property }: Props) => {
  const { control } = useFormContext<PaymentRequestForm>();
  const { placeholder, maxChars, minChars, id } = property;
  const { t } = useTranslation();

  const inputProps = useMemo(() => {
    return {
      placeholder: placeholder,
    };
  }, [placeholder]);

  const rules = useMemo(() => {
    return {
      maxLength: {
        value: maxChars ?? TEXT_MAX_CHARS,
        message: t('transaction_items.validation_message.text.length', {
          maxLength: maxChars ?? TEXT_MAX_CHARS,
          minLength: minChars ?? 0,
        }),
      },
      minLength: {
        value: minChars ?? 0,
        message: t('transaction_items.validation_message.text.length', {
          maxLength: maxChars ?? TEXT_MAX_CHARS,
          minLength: minChars ?? 0,
        }),
      },
    };
  }, [maxChars, minChars, t]);

  return (
    <FormInput<PaymentRequestForm>
      control={control}
      name={`invoiceTransactions.${index}.custom_transaction_items.${id}`}
      inputId={`${id}${index}`}
      inputProps={inputProps}
      rules={rules}
    />
  );
};
InnerTextTypeInput.displayName = 'InnerTextTypeInput';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const TextTypeInput = memo(
  InnerTextTypeInput
) as typeof InnerTextTypeInput;
TextTypeInput.displayName = 'TextTypeInput';
